const config = {
  ID: 'ESIGN_WAITING_STEP',
  BG_WHITE: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: false,
};

export default config;
